<template>
    <div>
        <!--Header & Create Inspection Button-->
        <div v-if="!isLoadingInspections && mutableInspections && mutableInspections.length > 0"
             class="mt-4 flex justify-between items-center select-none">
            <div>
                <h1 class="text-2xl font-light text-gray-400">Inspections for this asset</h1>
            </div>
            <button type="button" class="p-2 flex items-center" @click.prevent="openInspectionCreationModal">
                <icon-plus-circle class="h-4 w-4 mr-2"></icon-plus-circle>
                <span>Inspection</span>
            </button>
        </div>

        <!--Tickets Table-->
        <div v-if="mutableInspections.length > 0" class="flow-root">
            <div class="-my-2 overflow-x-auto -mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-2 align-middle px-6 lg:px-8">
                    <div class="overflow-hidden shadow rounded-md">
                        <table ref="ticketsTable" class="min-w-full divide-y divide-gray-300" :style="{ height: tableHeight + 'px' }">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col" class="py-2 px-4 text-left text-sm font-medium text-gray-900">
                                        <div>Inspection Date</div>
                                    </th>
                                    <th scope="col" class="px-3 py-2 text-left text-sm font-medium text-gray-900 hidden md:table-cell">
                                        <div>Inspection Type</div>
                                        <div class="text-indigo-600">Status</div>
                                    </th>
                                    <th scope="col" class="px-3 py-2 text-left text-sm font-normal text-gray-900">
                                        <div class="text-indigo-600 font-medium">Tenant</div>
                                        <div class="text-gray-900">{{ currentTailwindBreakpoint >= 2 ? "Inspector" : "Type" }}</div>
                                    </th>
                                    <th scope="col" class="relative py-2 pl-3 pr-4 sm:pr-6 hidden md:table-cell"></th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 bg-white" ref="rowDropdownMenuAnchor">
                                <inspection-row-in-list-for-asset v-for="inspection in mutableInspections" :key="inspection.id" :inspection="inspection"
                                                                  @show-summary-modal="handleShowSummaryModalEvent(inspection)"
                                >
                                </inspection-row-in-list-for-asset>

                                <tr v-if="mutableInspections" v-for="i in emptyRows" :key="'empty-' + i" class="invisible">
                                    <td class="py-2 text-white">
                                        <!--This is to match the height of a typical row for the table height management to calculate correctly-->
                                        <span class="invisible block">Placeholder</span>
                                        <span class="invisible block">Placeholder</span>
                                    </td>
                                    <td class="py-2 text-white"></td>
                                    <td class="py-2 text-white"></td>
                                    <td class="py-2 text-white hidden md:table-cell"></td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="flex justify-center">
                            <plain-pagination
                                v-if="mutableInspections && (paginationData.next_page_url || paginationData.prev_page_url)"
                                :meta="paginationData"
                                padding="2"
                                @page-changed="fetchInspections">
                            </plain-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="!isLoadingInspections" class="mt-8 select-none text-center flex items-center justify-center text-light text-3xl text-gray-400">
            <div class="flex flex-col items-center">
                <div>No inspections for this asset yet</div>
                <button type="button" class="p-2 flex items-center text-sm hover:text-indigo-600" @click.prevent="openInspectionCreationModal">
                    <icon-plus-circle class="h-4 w-4 mr-2"></icon-plus-circle>
                    <span>Inspection</span>
                </button>
            </div>
        </div>

        <div v-else class="relative mt-10 flex items-center justify-center">
            <loading-indicator></loading-indicator>
        </div>
    </div>
</template>

<script>
import PlainPagination from "../library/PlainPagination.vue";
import TableHeightManagementMixin from "../../mixins/table-height-management-mixin";
import SimplePaginatorMixin from "../../mixins/simple-paginator-mixin";
import InspectionRowInListForAsset from "./InspectionRowInListForAsset.vue";

export default {
    name: "inspection-list-for-asset",
    components: {InspectionRowInListForAsset, PlainPagination},
    mixins: [TableHeightManagementMixin, SimplePaginatorMixin],
    props: ["assetId"],
    data () {
        return {
            mutableInspections: [],
            isLoadingInspections: false,
            selectedInspection: null,
            showInspectionModal: false,

        };
    },
    mounted () {
        this.fetchInspections();
    },
    methods: {
        handleShowSummaryModalEvent (ticket) {
            this.selectedInspection = ticket;
            this.showInspectionModal = true;
        },

        fetchInspections (paginationSettings = null) {
            this.isLoadingInspections = true;

            let page = 1;
            let perPage = 10;

            if (paginationSettings) {
                page = new URL(paginationSettings).searchParams.get("page");
            }

            axios.get(`/inspections/all`, {
                params: {
                    page: page,
                    per_page: perPage,
                    asset_filter: this.assetId,
                    archived_filter: "both",
                    sort: {"date": "desc"}
                }
            }).then(response => {
                this.mutableInspections = response.data.data;
                this.setPaginatorData(response.data);
                this.setMaxItemsPreviouslyLoaded();
            }).catch(errors => {
                toastr.error("Error retrieving tickets for asset.");
            }).finally(() => {
                this.isLoadingInspections = false;
            });
        },

        openInspectionCreationModal () {
            this.$emit("open-inspection-creation-modal");
        }
    }
};

</script>


<style scoped>

</style>
